(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('InvalidStoreCtrl', forgotPasswordCtrl);

    function forgotPasswordCtrl($rootScope, $scope, $location) {
        $rootScope.showHeader = false;
        $scope.shop = $location.search().shop;

        if (!$scope.shop) {
            $location.path('/');
        }
    }
})();
